import { render } from "./termOfValidity.vue?vue&type=template&id=0233393c&scoped=true"
import script from "./termOfValidity.vue?vue&type=script&lang=js"
export * from "./termOfValidity.vue?vue&type=script&lang=js"

import "./termOfValidity.vue?vue&type=style&index=0&id=0233393c&scoped=true&lang=css"
import "./termOfValidity.vue?vue&type=style&index=1&id=0233393c&lang=css"
script.render = render
script.__scopeId = "data-v-0233393c"

export default script